import { useTranslation } from 'react-i18next';

import { View } from '@aws-amplify/ui-react';
import { StyleSheet } from '@react-pdf/renderer';

import { LegendItem } from './LegendItem';

export const Legend = ({ isExamplePage }: { isExamplePage: boolean }) => {
  const { t } = useTranslation();
  const legendItemInfo = [
    isExamplePage ? 'Done' : t('statuses.done'),
    isExamplePage ? 'In progress' : t('statuses.inProgress'),
    isExamplePage ? 'To do' : t('statuses.toDo'),
  ];
  return (
    <View style={styles.wrap}>
      {legendItemInfo.map((info) => (
        <LegendItem key={info} info={info} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
  },
});
